import { PurchaseStepE } from "components/Pages/Purchases_new/models/enums";
import { useContent } from "contexts/contentContext/contentContext";
import ModalNavigationButtons from "../ModalNavigationButtons/ModalNavigationButtons";
import {
  type Dispatch,
  memo,
  type SetStateAction,
  useCallback,
  useState,
} from "react";
import FirstStepSection from "./components/FirstStepSection/FirstStepSection";
import SecondStepSection from "./components/SecondStepSection/SecondStepSection";
import PaymentForm from "./components/PaymentForm/PaymentForm";

import styles from "./paymentMethodSection.module.scss";
import s from "../thanksActionModals.module.scss";

interface PaymentMethodSectionI {
  handleBack: (modalId: string) => void;
  transactionAmount: number;
  step: PurchaseStepE;
  setStep: Dispatch<SetStateAction<PurchaseStepE>>;
  isFailed: boolean;
  setIsFailed: Dispatch<SetStateAction<boolean>>;
}

const ThanksPaymentMethodSection = memo(
  ({
    handleBack,
    transactionAmount,
    step,
    setStep,
    isFailed,
    setIsFailed,
  }: PaymentMethodSectionI) => {
    const { getTextByKey } = useContent();

    const [iframeUrl, setIframeUrl] = useState("");

    const isFirsStep = step === PurchaseStepE.FIRST_PURCHASE_METHOD_STEP;
    const isSecondStep = step === PurchaseStepE.SECOND_INVOICE_DETAILS_STEP;
    const isThirdStep = step === PurchaseStepE.THIRD_PAYMENT_STEP;

    const handleNextStep = useCallback(() => {
      if (step === PurchaseStepE.FIRST_PURCHASE_METHOD_STEP) {
        setStep(PurchaseStepE.SECOND_INVOICE_DETAILS_STEP);
      }
    }, [setStep, step]);

    const handlePreviousStep = useCallback(() => {
      if (isSecondStep) {
        setStep(PurchaseStepE.FIRST_PURCHASE_METHOD_STEP);
      }
    }, [isSecondStep, setStep]);

    return (
      <>
        <div
          className={`${styles.paymentMethodWrap} ${
            isSecondStep ? styles.secondStepWrap : ""
          }`}
        >
          {isFirsStep && <FirstStepSection />}
          {isSecondStep && (
            <SecondStepSection
              step={step}
              setStep={setStep}
              setIframeUrl={setIframeUrl}
              transactionAmount={transactionAmount}
            />
          )}

          {isThirdStep && (
            <PaymentForm
              iframeUrl={iframeUrl}
              isFailed={isFailed}
              setIsFailed={setIsFailed}
              setStep={setStep}
              transactionAmount={transactionAmount}
              setIframeUrl={setIframeUrl}
            />
          )}
        </div>

        {!isSecondStep && (
          <div
            className={`${s.purchaseBtnsWrap} ${
              isThirdStep ? styles.btnPosForTirdStep : ""
            }`}
          >
            <ModalNavigationButtons
              handleBack={isSecondStep ? handlePreviousStep : handleBack}
              handleNext={handleNextStep}
              nextButtonText={getTextByKey("next")}
              backButtonText={getTextByKey("back-text")}
              isThirdStep={isThirdStep}
            />
          </div>
        )}
      </>
    );
  }
);
export default ThanksPaymentMethodSection;
